export const GET_PRESCRIPTION_DATES_AND_LIST =
  "/api/v1/doctor/get_past_prescriptions";

export const VIEW_PRESCRIPTION_REV2 = "/user/view-prescription-rev2";
export const ADD_OR_SHARE_ERX = "/doctor/add-edit-e-prescription";
export const UPLOAD_MANUAL_RX = "/doctor/upload-manual-prescription-rev1";
export const SHARE_ERX = "/doctor/share-e-prescription";
export const APPROVE_AND_SHARE_ERX = "/api/v2/doctor/share-e-prescription";
